<template>
  <div class='contribute'>
    <div class="tab-bar">
      <div class="tab-radio">
        <div @click="changeType(item)" v-for="item in chkArr" :key="item.type" :class="item.type === type? 'radio-item active': 'radio-item'">
          <span>{{ item.name }}</span>
        </div>
      </div>
      <div class="tab-page">
        <div @click="preBtn" :class="pageNum <= allPage? 'page page-next disabled': 'page page-next'">上一页</div>
        <div @click="nextBtn" :class="pageNum >= allPage? 'page page-next disabled': 'page page-next'">下一页</div>
      </div>
    </div>

    <div class="recommend-list" v-for="(item, index) in list" :key="index">
      <div class="recommend-item">
        <div class="img">
          <img :src="item.title_pic" alt="">
        </div>
        <div class="text">
          <div class="recommend-title">{{ item.creation_name }}</div>
          <p class="recommend-date">{{ item.create_time.slice(0, 10) }}</p>
        </div>
        <div class="bottom">
          <div v-if="type === 1" class="bottom-item" @click="showInfo(item)">查看</div>
          <div class="bottom-item" @click="showDesignerInfo(item)">修改</div>
        </div>
      </div>

      <div v-if="type === 2" class="unPass">
        <span>未通过理由：</span>{{ item.chk_desc }}
      </div>
    </div>
    <DesignerInfo v-if="showPopup" :show="showPopup" :info="info" @close="showPopup = false"></DesignerInfo>
    <DesignerSignup v-if="showDesignSignup" :show="showDesignSignup" :info="info" :userInfo="userInfo" @close="showDesignSignup = false" @refresh="getList()"></DesignerSignup>
  </div>
</template>

<script>
import axios from 'axios'
const md5 = require('js-md5')
import DesignerSignup from "@/components/designerSignup.vue"
import DesignerInfo from "@/components/designerInfo.vue"

export default {
  name: 'contribute',
  components: {
    DesignerInfo,
    DesignerSignup
  },
  props: {
    userInfo: {}
  },
  data() {
    return {
      type: 1,
      chkArr: [
        { name: '审核通过', type: 1 },
        { name: '审核未通过', type: 2 },
        { name: '待审核', type: 0 }
      ],
      list: [],
      pageNum: 1,
      pageSize: 10,
      allPage: 1,
      info: {},
      showPopup: false,
      showDesignSignup: false
    }
  },
  computed: { },
  watch: {},
  created() {
    this.getList()
  },
  mounted() {
  },
  methods: {
    preBtn() {
      if (this.pageNum <= this.allPage) {
        return false
      }
      this.pageNum = this.pageNum - 1
      this.getList()
    },
    nextBtn() {
      if (this.pageNum >= this.allPage) {
        return false
      }
      this.pageNum = this.pageNum + 1
      this.getList()
    },
    getList() {
      const stamp = Date.now()
      const user_id = JSON.parse(localStorage.getItem('giftsUser')).id
      const data = {
        stamp,
        user_id,
        chk_type: this.type,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        sign: md5(stamp + '' + this.pageNum + '' + this.pageSize + '' + atob(localStorage.getItem('okey')))
      }
      axios.get('/interface/searchCreation', { params: data }).then(res => {
        console.log(123123, res)
        if (res.data.result === 1) {
          this.allPage = Math.ceil(res.data.total / this.pageSize)
          if (this.allPage === 0) {
            this.allPage = 1
          }
          console.log(this.allPage)
          this.list = res.data.data
          this.$message({message: res.data.msg, type: 'success'})
        } else {
          this.$message(res.data.msg)
        }
      })
    },
    changeType(item) {
      if (item.type !== this.type) {
        this.type = item.type
        this.list = []
        this.getList()
      }
    },
    showInfo(item) {
      this.info = item
      this.showPopup = true
    },
    showDesignerInfo(item) {
      this.info = item
      this.showDesignSignup = true
    }
  }
}
</script>
<style lang='less' scoped>
.contribute {
  margin-top: 35px;
  .tab-bar {
    border-bottom: 1px solid #ccc;
    display: flex;
    justify-content: space-between;
    margin-bottom: 25px;
    .tab-radio{
      display: flex;
      padding-left: 23px;
      .radio-item {
        cursor: pointer;
        position: relative;
        margin-right: 35px;
        padding-right: 35px;
        font-size: 24px;
        font-weight: 400;
        color: #999999;
        line-height: 53px;
        &:not(:last-child)::after {
          content: '';
          right: 0;
          top: 15px;
          position: absolute;
          display: inline-block;
          width: 1px;
          height: 18px;
          background: #CCCCCC;
        }
        &.active{
          font-weight: 600;
          color: #4E8B46;
          span {
            display: inline-block;
            line-height: 53px;
            border-bottom: 4px solid #4E8B46;
          }
        }
      }
    }
    .tab-page {
      display: flex;
      align-items: center;
      .page {
        cursor: pointer;
        width: 100px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 12px;
        border-radius: 4px;
        border: 1px solid #B8D4B4;
        font-size: 20px;
        font-weight: 400;
        color: #999999;
        color: #4E8B46;
        &.disabled{
          cursor: not-allowed;
          color: #999;
          border: 1px solid #999999;
        }
      }
    }
  }
  .recommend-list{
    border: 1px solid #B8D4B4;
    border-radius: 15px;
    margin-bottom: 17.5px;
    .recommend-item{
      position: relative;
      display: flex;
      padding: 23px;
      .img{
        width: 144px;
        height: 144px;
        background: #FFFFFF;
        border: 1px solid #E2E2E2;
        overflow: hidden;
        border-radius: 11px;
        margin-right: 24.5px;

        img {
          vertical-align: top;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .text {
        text-align: left;
        flex: 1;
        .recommend-title {
          font-size: 24px;
          font-weight: 400;
          color: #4E8B46;
          margin-bottom: 25px;
        }
        .recommend-date {
          font-size: 18px;
          font-weight: 400;
          color: #999999;
        }
      }
      .bottom{
        display: flex;
        position: absolute;
        right: 27px;
        bottom: 34px;
        .bottom-item {
          cursor: pointer;
          width: 160px;
          height: 50px;
          line-height: 50px;
          border: 1px solid #B8D4B4;
          font-size: 20px;
          font-weight: 400;
          color: #4E8B46;
          border-radius: 50px;
          margin-right: 24.5px;
        }
      }
    }

    .unPass{
      border-top: 1px solid #ccc;
      padding: 20px;
      font-size: 18px;
      color: #999999;
      line-height: 24px;
      text-align: left;
      span{
        color: #DA0000;
      }
    }
  }
}
</style>
